module.exports = __webpack_public_path__ + "img/06.b00f1212.jpg";